import ClustersPage from "./ClustersPage";

export default function ClustersRoute() {
  return <ClustersPage />;
}
